import { ExportIconWhite } from '@/assets/images';
export const DocumentUploadLoader = () => {
  return (
    <div className="absolute left-0 top-0 z-50 flex size-full items-center justify-center rounded-[12px] bg-marveri-background">
      <div className=" flex flex-col items-center rounded-xl bg-[#323232] p-8 text-center text-marveri-light-silver">
        <div className="flex flex-col items-center space-y-6 text-center">
          <img src={ExportIconWhite} className="size-12 animate-bounce" />
          <div className="space-y-2">
            <h1 className="text-2xl font-medium text-white">Uploading Documents</h1>
            <p className="text-[16px] text-marveri-silver">Please keep this window open</p>
          </div>

          <div className="rounded-lg bg-[#3A3A3A] p-4 text-sm text-marveri-white">
            Do not close this window until upload is complete
          </div>
        </div>
      </div>
    </div>
  );
};
